import moment from "moment";
import getDefaultFromDate from "./getDefaultFromDate";

export default function getDefaultToDate(): Date {
  return moment(getDefaultFromDate())
    .add(VisitWidget.settings.eventDefaultDateRangeNumberOfMonths, "months")
    .toDate();
}
